export function scrollToSection(id: string) {
  const plansSection = document.querySelector(id);

  if (plansSection) {
    setTimeout(() => {
      plansSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }
}

export function scrollToPlans() {
  scrollToSection('#plans');
}
